export const BRAND_CATEGORY_LABELS: Record<string, string> = {
  technology: "Tecnología",
  "financial services": "Servicios Financieros",
  healthcare: "Salud",
  pharmaceuticals: "Farmacéuticas",
  retail: "Retail",
  "e-commerce": "E-commerce",
  "food and beverage": "Alimentos y Bebidas",
  nutrition: "Nutrición",
  "restaurants and cafes": "Restaurantes y Cafeterías",
  "alcohol and beverages": "Alcohol y Bebidas",
  automotive: "Automotriz",
  telecommunications: "Telecomunicaciones",
  entertainment: "Entretenimiento",
  "gaming and video games": "Gaming y Videojuegos",
  education: "Educación",
  "real estate": "Inmobiliario",
  "construction and home improvement": "Construcción y Mejoras del Hogar",
  "travel and hospitality": "Viajes y Hospitalidad",
  "logistics and delivery": "Logística y Delivery",
  transportation: "Transporte",
  insurance: "Seguros",
  "fashion and apparel": "Moda y Vestuario",
  "beauty and cosmetics": "Belleza y Cosméticos",
  "personal care and hygiene": "Cuidado Personal e Higiene",
  "home and garden": "Hogar y Jardín",
  "household products": "Productos del Hogar",
  "sports and fitness": "Deportes y Fitness",
  "media and publishing": "Medios y Publicaciones",
  "books and bookstores": "Libros y Librerías",
  "professional services": "Servicios Profesionales",
  "legal services": "Servicios Legales",
  "energy and utilities": "Energía y Servicios Públicos",
  gambling: "Apuestas",
  "cryptocurrency and fintech": "Fintech",
  "government and non-profit": "Gobierno y ONGs",
  pets: "Mascotas",
  "consumer electronics": "Electrónica de Consumo",
  "software and saas": "Software y SaaS",
  "security and safety": "Seguridad",
  "staffing and recruitment": "Recursos Humanos y Reclutamiento",
  "toys and games": "Juguetes y Juegos",
  other: "Otros",
};

// Array of category keys for filters
export const BRAND_CATEGORIES = Object.keys(BRAND_CATEGORY_LABELS);
